module.exports = __webpack_public_path__ + "img/poster-clip-bg.0d53783d.png";